/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

$(document).ready(function () {

  // PRODUCT ACCORDION
    $("body").on("click", ".pro-meta-accordion-title", function () {
        var activeTitle = $(this);
        activeTitle.toggleClass("active");
        var currentDropdown = activeTitle.next(".pro-meta-accordion-text");
        $(".pro-meta-accordion-title").not(activeTitle).removeClass("active");
        $(".pro-meta-accordion-text").not(currentDropdown).slideUp();
        currentDropdown.stop(true, true).slideToggle();
    });

  $("body").on("click", ".faq-sec-block-title", function () {
      var activeTitle = $(this);
      activeTitle.toggleClass("active");
      var currentDropdown = activeTitle.next(".faq-sec-block-content");
      $(".faq-sec-block-title").not(activeTitle).removeClass("active");
      $(".faq-sec-block-content").not(currentDropdown).slideUp();
      currentDropdown.stop(true, true).slideToggle();
  });

  // SIZE GUIDE
    // Initialize original values as data attributes
    $(".size-chart-item_content table tbody tr").each(function () {
        $(this).find("td").each(function (index) {
        const value = parseFloat($(this).text().trim());
        if (!isNaN(value)) {
            $(this).attr("data-in", value); // Store original IN values
            $(this).attr("data-cm", (value * 2.54).toFixed(0)); // Store converted CM values
        }
        });
    });
    $("body").on("click", ".size-chart-converter_item", function () {
      var $sizeChartItem = $(this).closest(".size-chart-item"); // Get parent chart item
      $sizeChartItem.find(".size-chart-converter_item").removeClass("active");
      $(this).addClass("active");

      // Determine the selected unit
      const unit = $(this).data("type"); // "CM" or "IN"

      // Update checkbox state
      var $unitToggle = $sizeChartItem.find(".unitToggle");
      $unitToggle.prop("checked", unit === "CM");

      // Update table values
      updateTableValues($sizeChartItem, unit);
    }); 

    // Listen for checkbox changes
    $("body").on("change", ".unitToggle", function () {
      var $sizeChartItem = $(this).closest(".size-chart-item"); // Get relevant chart section
      var unit = $(this).prop("checked") ? "IN" : "CM"; // Check checkbox state

      // Update the active class in size converter items
      $sizeChartItem.find(".size-chart-converter_item").removeClass("active");
      $sizeChartItem
        .find(`.size-chart-converter_item[data-type="${unit}"]`)
        .addClass("active");

      // Update table values
      updateTableValues($sizeChartItem, unit);
    });
    // Function to update table values
    function updateTableValues($sizeChartItem, unit) {
      $sizeChartItem.find("table tbody tr").each(function () {
        $(this)
          .find("td")
          .each(function () {
            const value =
              unit === "CM"
                ? $(this).attr("data-cm")
                : $(this).attr("data-in");

            $(this).text(value);
          });
      });
    }

});

(function () {
    function initSection(section) {
      if (section.dataset.stlsInit) return;
      section.dataset.stlsInit = 'true';

      var dots = section.querySelectorAll('.shop-the-look-sec__dot');
      var items = section.querySelectorAll('.shop-the-look-sec-content-item');

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var slide = dot.getAttribute('data-slide');
          dots.forEach(function (d) { d.classList.remove('active'); });
          dot.classList.add('active');
          items.forEach(function (item) {
            item.hidden = item.getAttribute('data-slide') !== slide;
          });
        });
      });
    }

    function initAll(root) {
      (root || document).querySelectorAll('.shop-the-look-secondary').forEach(initSection);
    }

    if (document.readyState !== 'loading') {
      initAll(document);
    } else {
      document.addEventListener('DOMContentLoaded', function () { initAll(document); });
    }

    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();
